// extracted by mini-css-extract-plugin
module.exports = {"UtilityBoxItem":"index-module__UtilityBoxItem___1wO80","childWrapper":"index-module__childWrapper___2zAQ9","icon":"index-module__icon____qTyV"};